import React from 'react';
import {
  LineChart as RechartsLineChart,
  Line,
  XAxis,
  YAxis,
  ResponsiveContainer,
  Tooltip,
} from 'recharts';
import AnalyticsEmptyState from "../../dashboard/AnalyticsEmptyState";

const ParagraphMomentLineChart = ({ data, totalResponses, graphColor }) => {
  const hasCategories =
    data && data[0] && data[0].Categories && data[0].Categories.length > 0;
  if (!hasCategories) {
    return <AnalyticsEmptyState />;
  }

  // Convert the Categories array into the format required for the line chart
  const lineData = data[0].Categories.map((category, index) => ({
    name: category.Title,
    value: category.Words,
    color: category.Color,
    index: index + 1, // Add an index for the X-axis
  }));

  // Custom tooltip content
  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      const { name, value } = payload[0].payload;
      return (
        <div
          style={{
            backgroundColor: 'white',
            padding: '10px',
            border: '1px solid #ccc',
            borderRadius: '5px',
          }}
        >
          <p style={{ margin: 0, fontWeight: 'bold' }}>{name}</p>
          <p style={{ margin: 0 }}>{`Score: ${value}`}</p>
        </div>
      );
    }
    return null;
  };

  // Custom legend
  const CustomLegend = ({ payload }) => {
    return (
      <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexWrap: 'wrap' }}>
        {payload.map((entry, index) => (
          <li
            key={`legend-item-${index}`}
            style={{ display: 'flex', alignItems: 'center', marginRight: 10, marginBottom: 5 }}
          >
            <div
              style={{
                width: 12,
                height: 12,
                backgroundColor: entry.color,
                marginRight: 8,
              }}
            ></div>
            <span>{`${entry.payload.name} (${entry.payload.value})`}</span>
          </li>
        ))}
      </ul>
    );
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        flex: 1,
        minHeight: 0,
        width: '100%',
      }}
    >
      <ResponsiveContainer width="100%" height={300}>
        <RechartsLineChart data={lineData}>
          <XAxis dataKey="index" label={{ value: 'Categories', position: 'insideBottom', fill: graphColor || undefined }} axisLine={false} tickLine={false} stroke={graphColor || 'black'} tick={{ fill: graphColor || undefined }} />
          <YAxis axisLine={false} tickLine={false} stroke={graphColor || 'black'} tick={{ fill: graphColor || undefined }} />
          <Tooltip content={<CustomTooltip />} />
          <Line
            type="monotone"
            dataKey="value"
            stroke={(data) => data.color}
            strokeWidth={2}
            dot={{ r: 5 }}
            activeDot={{ r: 8 }}
          />
        </RechartsLineChart>
      </ResponsiveContainer>
      <CustomLegend payload={lineData.map((entry) => ({
        color: entry.color,
        payload: entry,
      }))} />
    </div>
  );
};

export default ParagraphMomentLineChart;

